module.exports = __webpack_public_path__ + "static/media/hygiene.26f130df.jpg";